import React from "react";
import PropTypes from "prop-types";

import TextIcon from "@material-ui/icons/ShortText"
import MultipleIcon from "@material-ui/icons/RadioButtonChecked"
import CheckBoxIcon from "@material-ui/icons/CheckBox"
import ImageIcon from "@material-ui/icons/Image"


import {
    withStyles,
    Select,
    InputLabel,
    MenuItem,
    ListItemIcon,
    ListItemText,
    FormControl
} from "@material-ui/core";



class QuestionTypeSelector extends React.Component{

    state={
        questionType:"text"
    }


    componentDidMount(){
        const {value} = this.props;

        console.log("questionTypeSelector:",value)

        if(value){
            this.setState({questionType:value})
        }
    }

    onQuestionTypeChange=(event)=>{
        const {onQuestionTypeChange} = this.props
        this.setState({questionType:event.target.value})
        if(onQuestionTypeChange){
            onQuestionTypeChange(event.target.value);
        }
    }


    render(){

        const {classes,key} = this.props

        return(<div className={classes.root}>
            <FormControl className={classes.formControl}>
                <Select
                    value={this.state.questionType}
                    onChange={this.onQuestionTypeChange}
                    inputProps={{
                        name: `questionType-select-${key}`,
                        id: 'questionTypeSelect',
                    }}
                >
                    <MenuItem value={"text"}>
                        <ListItemIcon >
                            <TextIcon style={{color:"#fc824e"}}></TextIcon>
                        </ListItemIcon>
                        <ListItemText className={classes.menuText}>
                            Text Question
                        </ListItemText>
                       </MenuItem>
                       <MenuItem value={"checkbox"}>
                        <ListItemIcon >
                            <CheckBoxIcon  style={{color:"#fc824e"}}></CheckBoxIcon>
                        </ListItemIcon>
                        <ListItemText className={classes.menuText}>
                           Checkbox 
                        </ListItemText>
                       </MenuItem>
                    <MenuItem value={"multiple"}>
                        <ListItemIcon >
                            <MultipleIcon style={{color:"#fc824e"}}></MultipleIcon>
                        </ListItemIcon>
                        <ListItemText className={classes.menuText}>
                            Multiple Choice
                        </ListItemText>
                       </MenuItem>
                       <MenuItem value={"image"}>
                    <ListItemIcon >
                        <ImageIcon style={{color:"#fc824e"}}></ImageIcon>
                    </ListItemIcon>
                    <ListItemText className={classes.menuText}>
                        Image Answer
                    </ListItemText>
                </MenuItem>
                </Select>
            </FormControl>
            </div>
        )



    }



}

const styles={
    formControl: {
        minWidth: 150,
    },
    select:{

    }
    ,
    menuText:{
        padding:0,
        margin:0
    }

}

export default withStyles(styles)(QuestionTypeSelector);


// WEBPACK FOOTER //
// ./src/components/QuestionTypes/QuestionTypeSelector.jsx